import { connect } from 'react-redux';

import { Controls, IControlsProps } from '../../components/Gallery/Controls';
import { IState } from '../../store';
import { showGalleryElement } from '../../store/gallery';
import { TTypedThunkDispatch } from '../../types/store';
import { getPhotos, getVideos } from '../../utils/gallery_helpers';

export function mapStateToProps(state: IState) {
  const { isInitialized, isVideoPlaying } = state.gallery;
  const photoCount = getPhotos(state).length;
  const videoCount = getVideos(state).length;
  const photoFirstIndex = 0;
  const videoFirstIndex = photoCount;

  return {
    isInitialized,
    isVideoPlaying,
    photoCount,
    videoCount,
    photoFirstIndex,
    videoFirstIndex,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    onElementShow: (id: number) => {
      dispatch(showGalleryElement(id));
    },
  };
}

export const GalleryControlsContainer = connect<Partial<IControlsProps>, Partial<IControlsProps>>(
  mapStateToProps,
  mapDispatchToProps,
)(Controls);
